export default from './create-post-card';



// WEBPACK FOOTER //
// ./app/components/create-post-card/index.js